import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Clock, XCircle } from "lucide-react";
import api from "@/lib/api";
import useSeo from "@/lib/useSeo";

export default function CheckoutReturn() {
  const [params] = useSearchParams();
  const number = params.get("order");
  const [state, setState] = useState("pending");
  useSeo({ title: "Order status — ONUSA" });

  useEffect(() => {
    if (!number) return;
    let stopped = false;
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/orders/status/${number}`);
        if (stopped) return;
        setState(data.payment_status);
        tries += 1;
        if (data.payment_status === "pending" && tries < 20) setTimeout(poll, 2500);
      } catch { if (!stopped) setState("unknown"); }
    };
    poll();
    return () => { stopped = true; };
  }, [number]);

  const map = {
    paid: { icon: CheckCircle2, title: "BETALING BEVESTIGD", body: "Bedankt. Je ONUSA-bestelling is bevestigd en wordt klaargemaakt voor verzending." },
    pending: { icon: Clock, title: "IN AFWACHTING VAN BEVESTIGING", body: "We bevestigen je betaling serverside. Deze pagina wordt automatisch bijgewerkt — ververs niet." },
    failed: { icon: XCircle, title: "BETALING MISLUKT", body: "Je betaling is niet voltooid. Er is niets in rekening gebracht." },
    cancelled: { icon: XCircle, title: "BETALING GEANNULEERD", body: "Je hebt de betaling geannuleerd. Je winkelmand is nog beschikbaar." },
    unknown: { icon: Clock, title: "BESTELLING ONTVANGEN", body: "Je bestelling is geregistreerd." },
  };
  const s = map[state] || map.unknown;
  const Icon = s.icon;

  return (
    <div className="onusa-container py-24 md:py-32 text-center max-w-lg" data-testid="checkout-return-page">
      <Icon size={48} className="mx-auto mb-6" strokeWidth={1.2} />
      <p className="label-x">ORDER {number}</p>
      <h1 className="heading-x text-3xl mt-3" data-testid="return-status">{s.title}</h1>
      <p className="mt-4 text-[#77736D]">{s.body}</p>
      <div className="flex gap-3 justify-center mt-8">
        <Link to="/account/orders" className="btn-x-outline">BEKIJK BESTELLINGEN</Link>
        <Link to="/shop" className="btn-x">VERDER</Link>
      </div>
    </div>
  );
}
